@if (loading && !config) {
<section class="ks-card ks-card--skeleton">
  <div class="ks-card__groups">
    @for (_ of [0,1]; track $index) {
      <article class="ks-group">
        <div class="ks-group__top">
          <div class="ks-sk__name sk-bone"></div>
          <div class="ks-sk__state sk-bone"></div>
        </div>
        <div class="ks-group__items">
          @for (w of ['80%','60%','70%']; track $index) {
            <div class="ks-item">
              <div class="ks-sk__val sk-bone"></div>
              <div class="ks-sk__lbl sk-bone" [style.width]="w"></div>
            </div>
          }
        </div>
      </article>
    }
  </div>
</section>
} @else if (config) {
<section class="ks-card" [class.ks-card--refreshing]="loading">
  <div class="ks-card__groups">
    @for (group of config.groups; track group.label) {
      @let p = pct(group.cumplimiento);
      @let s = status(p);
      <article class="ks-group ks-group--{{ s }}"
               [style.border-left-color]="group.accent ?? null"
               [style.border-left-width]="group.accent ? '3px' : null">
        <div class="ks-group__top">
          <div class="ks-group__name">
            @if (group.icon) {
              <span class="ks-group__icon" [style.background]="(group.accent ?? '#6366f1') + '1a'" [style.border-color]="(group.accent ?? '#6366f1') + '44'">
                <i class="pi {{ group.icon }}" [style.color]="group.accent ?? '#6366f1'"></i>
              </span>
            }
            {{ group.label }}
          </div>
          <div class="ks-group__state">
            <i class="{{ statusIcon(p) }}"></i>
            <span>{{ statusText(p) }} · {{ hasCumplimiento(group.cumplimiento) ? p + '%' : '—' }}</span>
          </div>
        </div>

        <div class="ks-group__items">
          @for (item of group.stats; track item.label) {
            <div class="ks-item">
              <span class="ks-item__value">{{ item.value }}</span>
              <span class="ks-item__label">{{ item.label }}</span>
            </div>
          }
        </div>
      </article>
    }
  </div>
</section>
}
